<template>
    <div>

        <TextBanner>
       <p> Zentraler Baustein der <b>europäischen Forschung</b> ist das Weltraumlabor Columbus. Mehr als <b>360 Esa-Experimente</b> wurden bisher auf der ISS durchgeführt, etwa die Hälfte wurde von Deutschland in Auftrag gegeben. </p>
        <b>Drücken Sie auf den orangen Punkt, und erfahren Sie mehr über das Kleinste der sechs Labore.</b>
        </TextBanner>

        <InfoBox modalName="Columbus">
            <template #title>Das Weltraumlabor Columbus</template>
            <template #subline></template>
            <template>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/040_innen.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="600" data-height="600" v-lazy="require('../assets/img/040_innen_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Esa</div>
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <p>Das Columbus-Modul ist ein Mehrzwecklabor. Es wurde 2008 dauerhaft an die ISS montiert und in Betrieb genommen. Bis zu drei Astronaut*innen können gleichzeitig an wissenschaftlichen Experimenten arbeiten.</p>  
                
                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/040_querschnitt.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="600" data-height="600" v-lazy="require('../assets/img/040_querschnitt_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; ap/Esa/D. Ducros</div>
                        </figcaption>
                    </figure>
                </FullscreenImage>
                <p>Zehn Regale – sogenannte Racks - mit moderner Laborausrüstung, Computern und technischen Systemen sind hier untergebracht. Sie alle besitzen eine eigene Stromversorgung, Kühlsysteme sowie Video- und Datenleitungen.</p>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/040_gerst.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="632" data-height="632" v-lazy="require('../assets/img/040_gerst_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Nasa/Esa</div>
                        </figcaption>
                    </figure>
                </FullscreenImage>
                <p>Forscher*innen können per Fernsteuerung auch von der Erde aus in die Versuchsabläufe eingreifen und Daten abrufen.</p>

                <br>
                                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/040_aussen.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="700" data-height="461" v-lazy="require('../assets/img/040_aussen_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Nasa</div>
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <p>An der Außenhülle befinden sich vier Plattformen, an denen die Wissenschaftler*innen Versuche anbringen können. So können sie Daten zu den besonderen Bedingungen wie Weltraumstrahlung, Vakuum und Schwerelosigkeit direkt im Weltraum sammeln.</p>


            </template>
        </InfoBox>


        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_050_p.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_050_l.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>
            <div class="hotspot" v-on:click="infobox('Columbus')"></div>





        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                position: [1.3,.8,6],   //[1.56,0.1,30],
                target: [2,-1.7,4.6],       //[.5,0,0]
                useAutoRotationBehavior: true,
                idleRotationSpeed: 0.01,
            },
            

            iss: {


                Columbus: {
                    overlayColor: [48/255, 200/255, 242/255],
                    overlayAlpha: 0.6,
                    pickable: false,
                },

            },

            hotspots: {
                Russland: {
                    visible: true,
                    infoBox: 'Columbus',
                    position: [2.6, -1, 4.8],
                    scale: .6,
                    renderingGroupId: 0
                },
            },
           
        },
        babylonReady: function () {
            
        this.$babylonController.goToAnimation("spacex_anim", 0);

        this.$babylonController.timer.add(300, () => {
            this.$babylonController.setCameraRadiusLimit(4,200);
        });
        //this.$audioController.initTrack('speaker', require('./../assets/audio/2496003_Starhorizon_192.mp3'), true, false);


        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
